import React, { Component } from 'react';
import {
   DropDown
} from '@beisen/chaos-ui';
import * as urlHelper from '../util/url';
require('./pageNav.scss');
import classNames from 'classnames';

export default class SwitchView extends Component {
    constructor(props,context) {
        super(props,context);
        this.onTouchTap = this.onTouchTap.bind(this);
        this.dropDownExpand = this.dropDownExpand.bind(this);

        let navData = this.initData(props);
        this.state = navData;
    }
    componentWillReceiveProps(nextProps) {
        let navData = this.initData(nextProps);
        this.setState(navData);
    }

    shouldComponentUpdate(nextProps ,nextState) {
        return nextState.title != this.state.title || nextProps.tabstyle != this.props.tabstyle;
    }

    componentDidMount() {
        const tabActive = document.getElementsByClassName('active')[0];
        tabActive.scrollIntoView(true);
    }

    onTouchTap(view,e) {
        e.preventDefault();
        const { currentViewName } = this.state;
        // 增加拦截
        if(currentViewName === view.name) {
            return;
        }
        this.setState({
            title: view.label,
            currentViewName: view.name
        },function() {
            if(this.props.viewActived) {
            this.props.viewActived(view);
         }
        }.bind(this));
    }

    dropDownExpand() {
        this.props.repellentHandler && this.props.repellentHandler();
    }

    initData(props) {
        const { biz_data, sub_cmps, cmp_data } = props;
        let NavData = {
            title: (biz_data[cmp_data.currentViewName] && biz_data[cmp_data.currentViewName].text) || ''
            ,currentViewName: cmp_data.currentViewName
            ,data: []
        };

        const subCmps = sub_cmps.filter((item, index) => {
            return biz_data[item.cmp_data.name];
        });
        subCmps.forEach(item => {
            if(item.cmp_data && item.cmp_data.name && biz_data[item.cmp_data.name]) {
            const Item = {
                name: item.cmp_data.name ,
                metaObjName: item.cmp_data.metaObjName,
                label: (biz_data[item.cmp_data.name] && biz_data[item.cmp_data.name].text)  ||  '',
                value: item.cmp_name,
                cmp_data: item.cmp_data
            };
            NavData.data.push(Item);
            }
        });

        return NavData;
    }

    render() {
        if(this.props.sub_cmps.length == 1) {
            let title = this.props.biz_data[this.props.cmp_data.currentViewName] ? this.props.biz_data[this.props.cmp_data.currentViewName].text : '';
            return <span role='center'> {title} </span>;
        }

        return (
            <DropDown role='center'
                        {...this.state}
                        registerEvent={'showDropDown'}
                        onTouchTap={this.onTouchTap}
                        showChange={this.props.showChange}
                        dropDownExpand={this.dropDownExpand}
                        />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PageNav/SwitchView.js